import React, { useState, useEffect, useRef, Suspense, useContext } from "react";
import Chart from "chart.js/auto";
import { getProjectTaskList, TaskSummary } from "./Service/TaskService.js";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min.js";
import AddTask from "./Add-Task.jsx";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader.jsx";
import { render } from "@testing-library/react";
import { TostMsg } from "../../../App.js";

const TashManagementDashboard = () => {
  const [range, setRange] = useState("30");
  const [myTaskFilter, setMyTaskFilter] = useState("all");
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [acts, setActs] = useState([]);
  const [recentActivity, setRecentActivities] = useState([]);
  const [recentProject, setRecentProjects] = useState([]);
  const [summary, setSummary] = useState([]);
  const [taskActivity, setTaskActivity] = useState([]);
  const [teamPerformance, setteamPerformance] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [taskList, setTaskList] = useState([]);
  const history = useHistory();
  const [isModalOpen, setAddModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const toster = useContext(TostMsg);

  useEffect(() => {
    getTaskSummary();
    getProjectTask();
  }, [range]);

  async function getTaskSummary() {
    const params = {
      DateRange: Number(range),
    };
    setIsLoading(true);
    try {
      const response = await TaskSummary(params);
      if (response?.StatusCode === 2000) {
        setRecentActivities(response?.Data?.RecentActivity);
        setRecentProjects(response?.Data?.RecentProjects);
        setSummary(response?.Data?.Summary);
        setTaskActivity(response?.Data?.TaskActivity);
        setteamPerformance(response?.Data?.TeamPerformance);
      }
      setIsLoading(false);
    } catch (error) {
      toster.current.error(error?.response?.Message || "somthing went wrong");
      setIsLoading(false);
    }
  }

  async function getProjectTask() {

    const params = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: userDetails?.EmpId,
      RaisedByEmpId: "",
      AssignedToId: userDetails?.EmpId?.toString(),
      TaskId: 0,
      StatusId: "",
      ModuleId: "",
      SubModuleId: "",
      PriorityId: "",
      SeverityId: "",
      Search: "",
      FilterStartDate: "",
      FilterEndDate: "",
      PageNumber: 1, // ✅ dynamic
      PageSize: 10, // ✅ dynamic
      IsDeleted: 0,
      SprintId: 0,
      TaskNumber: "",
      TaskTypeId: "",
      SegmentId: "",
      SortBy: "",
      SortOrder: "ASC",
    };
    setIsLoading(true);
    try {
      const data = await getProjectTaskList(params);
      const list = data?.Data?.OrgEmpTasks || [];

      setTaskList(list);
      setIsLoading(false);
      //  setIsloading(false);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    } finally {
      setIsLoading(false);

    }
  }

  const navigateTaskDetailPage = (task) => {
    history.push(`/Project/Task/Detail/${task?.GUID}`);
  };
  // Helper functions
  const sBadge = (status) => {
    const map = {
      Open: "bg-open",
      "In Progress": "bg-inprog",
      Review: "bg-review",
      Closed: "bg-closed",
    };
    return map[status] || "bg-muted";
  };

  const pBadge = (priority) => {
    const map = {
      High: "bg-high",
      Medium: "bg-medium",
      Low: "bg-low",
    };
    return map[priority] || "bg-muted";
  };

  const fmtDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const formatLabel = (key) => {
    return key
      .replace(/InActive/g, "Inactive")
      .replace(/([A-Z])/g, " $1")
      .trim();
  };

  // Render KPIs
  const renderKPIs = () => {

    // return Object.entries(summary).map(([key, value], i) => (
    //   <div key={i} className={`sc`}>
    //     <div className="sc-lab">{formatLabel(key)}</div>
    //     <div className="sc-val">{value}</div>
    //   </div>
    // ));


    return (
      <>
        <div className="sc purple-active-task" onClick={() => history.push('/Project/List')}>
          <div className="sc-lab">Total Projects</div>
          <div className="sc-val">{summary?.TotalProjects || 0}</div>
        </div>

        <div className="sc active-task" onClick={() => history.push('/Project/List')}>
          <div className="sc-lab">Active Projects</div>
          <div className="sc-val">{summary?.ActiveProjects || 0}</div>
        </div>

        <div className="sc blue-active-task" onClick={() => history.push('/Project/List')}>
          <div className="sc-lab">Inactive Projects</div>
          <div className="sc-val">{summary?.InActiveProjects || 0}</div>
        </div>

        <div className="sc purple-active-task" onClick={() => history.push('/Project/Tasks/All')}>
          <div className="sc-lab">Total tasks</div>
          <div className="sc-val">{summary?.TotalTasks || 0}</div>
        </div>

        <div className="sc active-task" onClick={() => history.push('/Project/Tasks/All')}>
          <div className="sc-lab">Active Tasks</div>
          <div className="sc-val">{summary?.ActiveTasks || 0}</div>
        </div>

        <div className="sc red-active-task" onClick={() => history.push('/Project/Tasks/All')}>
          <div className="sc-lab">Overdue Tasks</div>
          <div className="sc-val">{summary?.OverdueTasks || 0}</div>
        </div>
      </>
    );
  };

  const renderTaskChart = () => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext("2d");

    const labels = [];
    const created = [];
    const closed = [];

    taskActivity.forEach((item) => {
      const date = new Date(item.ActivityDate);

      labels.push(
        date.toLocaleDateString("en-IN", {
          day: "numeric",
          month: "short",
        }),
      );

      created.push(item.CreatedCount);
      closed.push(item.ClosedCount);
    });

    chartInstance.current = new Chart(ctx, {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: "Created",
            data: created,
            borderColor: "#EC4119",
            backgroundColor: "rgba(236,65,25,0.07)",
            tension: 0.4,
            fill: true,
            pointRadius: 1.5,
            borderWidth: 2,
          },
          {
            label: "Closed",
            data: closed,
            borderColor: "#10b981",
            backgroundColor: "rgba(16,185,129,0.05)",
            tension: 0.4,
            fill: true,
            pointRadius: 1.5,
            borderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { display: false },
          tooltip: { mode: "index", intersect: false },
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              font: { size: 10, family: "Onest" },
              color: "#888",
              maxRotation: 0,
              maxTicksLimit: 8,
            },
          },
          y: {
            grid: { color: "#f0f2f5" },
            ticks: {
              font: { size: 10, family: "Onest" },
              color: "#888",
            },
          },
        },
      },
    });
  };

  // Render My Tasks
  const renderMyTasks = () => {
    if (!taskList.length) {
      return (
        <div className="empty">
          <i className="fa-solid fa-circle-check"></i>
          <p>No tasks in this view</p>
        </div>
      );
    }

    return taskList.map((t) => {
      return (
        <div
          key={t.Id}
          className="mytask-row"
          onClick={() => navigateTaskDetailPage(t)}
        // style={{ flex: 1, minWidth: 0 }}
        >
          <div>
            <div className="mytask-title">{t.TaskTitle}</div>
            <div className="mytask-proj">
              {t.TaskNumber} &nbsp;·&nbsp; {t ? t.name : ""}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row-reverse",
                  alignItems: "center",
                  gap: "3px",
                  flexShrink: 0,
                }}
              >
                <span
                  className={`badge ${sBadge(t.StatusName)}`}
                  style={{ fontSize: "10px" }}
                >
                  {t.StatusName}
                </span>
                <span
                  className={`text-muted badge ${pBadge(t.PriorityName)}`}
                  style={{ fontSize: "10px" }}
                >
                  {t.PriorityName}
                </span>
                {t.DueDate && (
                  // color: ov ? 'var(--red)' : 'var(--muted)'
                  <span className="me-1" style={{ fontSize: "10px" }}>{fmtDate(t.DueDate)}</span>
                )}
              </div>
            </div>
          </div>

        </div>
      );
    });
  };

  const renderPerfTable = () => {
    const rows = teamPerformance.map((member) => {
      return (
        <tr key={member.UserId}>
          <td>
            <div style={{ fontWeight: 600, fontSize: "12px" }}>
              {member.MemberName}
            </div>
          </td>
          <td style={{ textAlign: "center" }}>{member.AssignedCount}</td>
          <td style={{ textAlign: "center" }}>{member.InProgressCount}</td>
          <td
            style={{
              textAlign: "center",
              color: member.OverdueCount ? "var(--red)" : "var(--muted)",
            }}
          >
            {member.OverdueCount}
          </td>
        </tr>
      );
    });

    return (
      <>
        <thead>
          <tr>
            <th>Member</th>
            <th style={{ textAlign: "center" }}>Open</th>
            <th style={{ textAlign: "center" }}>In Progress</th>
            <th style={{ textAlign: "center" }}>Overdue</th>
          </tr>
        </thead>
        <tbody>
          {/* {teamPerformance?.length > 0 ? ( */}
          {rows}
          {/* ) : (<tr><td colspan="4" style={{"textAlign": "center"}}>No team performance yet.</td></tr>)} */}
        </tbody>
      </>
    );
  };

  // Render Recent Activity
  // const renderActivity = () => {
  //   // const acts = [
  //   //   { icon: 'fa-plus', color: 'var(--green)', txt: '<strong>Priya Sharma</strong> created <strong>TM-025</strong>', time: '2m ago' },
  //   //   { icon: 'fa-arrow-right', color: 'var(--blue)', txt: '<strong>Rohit Yadav</strong> moved <strong>TM-018</strong> to In Progress', time: '14m ago' },
  //   //   { icon: 'fa-comment', color: 'var(--purple)', txt: '<strong>Ankit Verma</strong> commented on <strong>TM-012</strong>', time: '1h ago' },
  //   //   { icon: 'fa-check', color: 'var(--green)', txt: '<strong>Sneha Patel</strong> closed <strong>TM-009</strong>', time: '2h ago' },
  //   //   { icon: 'fa-user', color: 'var(--amber)', txt: '<strong>Vikram Singh</strong> assigned <strong>TM-022</strong> to Deepa', time: '3h ago' },
  //   // ];

  //   return (
  //     <div className="tl">
  //       {recentActivity.map((a, i) => (
  //         <div key={i} className="tl-item">
  //           <div className="tl-dot" style={{ background: a.color + '18', color: a.color, borderColor: 'var(--card)' }}>
  //             <i className={`fa-solid ${a.icon}`} style={{ fontSize: '10px' }}></i>
  //           </div>
  //           <div className="tl-body">
  //             <div style={{ fontSize: '12.5px' }} dangerouslySetInnerHTML={{ __html: a.txt }} />
  //             <div className="tl-time">{a.time}</div>
  //           </div>
  //         </div>
  //       ))}
  //     </div>
  //   );
  // };

  const renderActivity = () => {
    const getIconAndColor = (action, entity) => {
      if (action.includes("updated")) {
        return { icon: "fa-pen", color: "var(--blue)" };
      }
      if (action.includes("modified")) {
        return { icon: "fa-gear", color: "var(--amber)" };
      }
      if (action.includes("created")) {
        return { icon: "fa-plus", color: "var(--green)" };
      }
      return { icon: "fa-circle", color: "var(--muted)" };
    };

    const formatTime = (dateString) => {
      const now = new Date();
      const past = new Date(dateString);
      const diff = Math.floor((now - past) / 1000);

      if (diff < 60) return `${diff}s ago`;
      if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
      if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
      return `${Math.floor(diff / 86400)}d ago`;
    };

    return (
      <div className="tl">
        {/* {renderActivity?.length > 0 ? ( */}
        {recentActivity.map((a, i) => {
          const { icon, color } = getIconAndColor(a.ActionType, a.EntityType);

          const txt = `<strong>${a.MemberName}</strong> ${a.ActionType} <strong>${a.EntityType}</strong> (${a.EntityName})`;

          return (
            <div key={i} className="tl-item">
              <div
                className="tl-dot"
                style={{
                  background: color + "18",
                  color: color,
                  borderColor: "var(--card)",
                }}
              >
                <i
                  className={`fa-solid ${icon}`}
                  style={{ fontSize: "10px" }}
                ></i>
              </div>

              <div className="tl-body">
                <div
                  style={{ fontSize: "12.5px" }}
                  dangerouslySetInnerHTML={{ __html: txt }}
                />
                <div className="tl-time">{formatTime(a.ActivityDate)}</div>
              </div>
            </div>
          );
        })}

        {/* ) : (
          <p style={{"textAlign" : "center"}}>No activity yet.</p>
        )} */}
      </div>
    );
  };

  // Handle filter change
  const handleFilterChange = (filter, e) => {
    setMyTaskFilter(filter);

    // Remove active from all pills
    document.querySelectorAll(".active-pill").forEach((btn) => {
      btn.classList.remove("active-pill");
    });

    // Add active to clicked button
    e.target.classList.add("active-pill");
  };
  // const activeModule = getParam('module') || 'dashboard';

  // Initial render: set today date and chart, cleanup on unmount
  useEffect(() => {
    const todayEl = document.getElementById("todayDate");
    if (todayEl) {
      todayEl.textContent = new Date().toLocaleDateString("en-IN", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }

    renderTaskChart();
    renderKPIs();

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [taskActivity]);

  const onClosePopup = (e) => {

    setAddModalOpen(false);
    history.push("/Project/Tasks/All");

  };

  return (
    <div className="">
      {/* <TMDrawer active={activeModule} DATA={DATA} />  */}
      {/* <TaskSidebar/> */}

      {/* MAIN AREA */}
      <div className="task-top-pane">
        <i class="fa fa-thumb-tack i-ico" aria-hidden="true"></i>
        <div className="task-top-pane-title">
          <h4>Welcome to OrgGenie</h4>
          <p>Manage your tasks, projects, and workspaces in one place.</p>
        </div>
      </div>
      <div className="tm-main-area">
        <div className="page-head">
          <div>
            <h2>Dashboard</h2>
            <div className="topbar-sub" id="todayDate"></div>
          </div>
          <div className="head-actions">
            <Link to="/Project/Help"
              className="btn btn-info text-white " title="Project help">
              <i class="fa fa-info" aria-hidden="true"></i>
            </Link>
            <select
              className="fs"
              style={{ width: "120px" }}
              value={range}
              onChange={(e) => setRange(e.target.value)}
            >
              <option value="7">Last 7 days</option>
              <option value="30" selected>
                Last 30 days
              </option>
              <option value="90">Last 90 days</option>
            </select>
            <button
              className="btn btn-brand btn-sm"
              onClick={() => {
                setAddModalOpen(true);
              }}
            >
              <i className="fa-solid fa-plus"></i> New Task
            </button>

            {/* <button className="btn-og theme-color btn-og-sm" onClick={() => ogOpenModal('regulariseModal')}><i className="fa fa-edit"></i> Request Regularization</button> */}
          </div>
        </div>

        <div className="page">
          <div className="flex" style={{ flex: 1, overflow: "hidden" }}>
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                // overflowY: "scroll",
                // height: "calc(100vh - 13vh)",
              }}
            >
              {/* KPI STRIP */}
              <div className="task-sstrip mb-0" id="kpiStrip">
                {renderKPIs()}
              </div>

              {/* MAIN ROW */}
              <div
                className="flex gap8 ic"
                style={{ alignItems: "flex-start" }}
              >
                {/* LEFT COLUMN */}
                <div className="dash-left" style={{ flex: 1, minWidth: 0 }}>
                  {/* Task Activity Chart */}
                  <div className="card">
                    <div className="ch">
                      <h5>Task Activity — Last {range} Days</h5>
                      <div className="mla flex gap8">
                        <span
                          style={{
                            fontSize: "11px",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <span
                            style={{
                              width: "9px",
                              height: "9px",
                              background: "var(--brand)",
                              borderRadius: "2px",
                              display: "inline-block",
                            }}
                          ></span>
                          Created
                        </span>
                        <span
                          style={{
                            fontSize: "11px",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <span
                            style={{
                              width: "9px",
                              height: "9px",
                              background: "var(--s-resolved)",
                              borderRadius: "2px",
                              display: "inline-block",
                            }}
                          ></span>
                          Closed
                        </span>
                      </div>
                    </div>
                    <div className="cb">
                      <canvas
                        ref={chartRef}
                        id="taskChart"
                        height="110"
                      ></canvas>
                    </div>
                  </div>


                  {/* Recent Activity */}
                  <div className="card">
                    <div className="ch">
                      <h5>Recent Activity</h5>
                    </div>
                    <div className="cb" style={{ padding: "12px 14px" }}>
                      {renderActivity()}

                      <div className="tl">
                        {acts.map((a, i) => (
                          <div key={i} className="tl-item">
                            <div
                              className="tl-dot"
                              style={{
                                background: a.color + "18",
                                color: a.color,
                                borderColor: "var(--card)",
                              }}
                            >
                              <i
                                className={`fa-solid ${a.icon}`}
                                style={{ fontSize: "10px" }}
                              ></i>
                            </div>

                            <div className="tl-body">
                              <div
                                style={{ fontSize: "12.5px" }}
                                dangerouslySetInnerHTML={{ __html: a.txt }}
                              />
                              <div className="tl-time">{a.time}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* RIGHT COLUMN - MY TASKS */}
                <div className="dash-right">
                  <div className="card" style={{ flex: 1 }}>
                    <div className="ch">
                      <h5>My Tasks</h5>
                      <span className="badge bg-inprog mla" id="myTaskCount">
                        {/* {DATA.tasks.filter(t => t.assignedTo === me &&
                      (myTaskFilter === 'all' ||
                        (myTaskFilter === 'open' && t.status === 'Open') ||
                        (myTaskFilter === 'inprog' && t.status === 'In Progress') ||
                        (myTaskFilter === 'review' && t.status === 'Review')
                      )).length} */}
                        {taskList?.length}
                      </span>
                      <Link
                        to={"/Project/Task/List"}
                        className="btn btn-ghost btn-sm p-0 bg-transparent "
                      // style={{ marginLeft: "6px" }}
                      >
                        All <i className="fa-solid fa-arrow-right"></i>
                      </Link>
                    </div>

                    {/* Filter Pills */}
                    {/* <div style={{ display: 'flex', gap: '6px', padding: '8px 12px', borderBottom: '1px solid var(--border-lt)', flexWrap: 'wrap' }}>
                  <button
                    className={`btn btn-sm ${myTaskFilter === 'all' ? 'active-pill' : ''}`}
                    onClick={(e) => handleFilterChange('all', e)}
                  >
                    All
                  </button>
                  <button
                    className={`btn btn-sm ${myTaskFilter === 'open' ? 'active-pill' : ''}`}
                    onClick={(e) => handleFilterChange('open', e)}
                  >
                    Open
                  </button>
                  <button
                    className={`btn btn-sm ${myTaskFilter === 'inprog' ? 'active-pill' : ''}`}
                    onClick={(e) => handleFilterChange('inprog', e)}
                  >
                    In Progress
                  </button>
                  <button
                    className={`btn btn-sm ${myTaskFilter === 'review' ? 'active-pill' : ''}`}
                    onClick={(e) => handleFilterChange('review', e)}
                  >
                    Review
                  </button>
                </div> */}

                    <div
                      id="myTasksList"
                      style={{
                        overflowY: "auto",
                        maxHeight: "calc(100vh - 280px)",
                      }}
                    >
                      {renderMyTasks()}
                    </div>
                  </div>

                  {/* Team Performance */}
                  <div className="card">
                    <div className="ch">
                      <h5>Team Performance</h5>
                      {/* <span style={{ fontSize: '11.5px', color: 'var(--muted)', marginLeft: 'auto' }}>Last 30 days</span> */}
                    </div>
                    <div className="cb p0">
                      <table className="perf-tbl">{renderPerfTable()}</table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <AddTask
          isOpen={isModalOpen}
          onClose={(e) => onClosePopup(e)}
          editTaskDetails={{}}
          subTaskProjectId={0}
          parentId={0}
          taskCopy={false}
        ></AddTask>
      )}

      {isLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default TashManagementDashboard;
